const timeouts = {
  INFO: 2000,
  ERROR: 5000
};

export default timeouts;
